import { useMigrationsStore } from '@/common/store/pinia/migrations';
import takeFirst from '@/common/utils/takeFirst';

const fetchMigrationName = async (migrationId: string): Promise<string> => {
  try {
    const migrationsStore = useMigrationsStore();
    let migration = migrationsStore.getItemById(migrationId);
    if (!migration) {
      await takeFirst(migrationsStore.fetchItem, migrationId);
      migration = migrationsStore.getItemById(migrationId);
    }
    return migration?.name || '';
  } catch (error) {
    console.error(`Failed to fetch migration with ID ${migrationId}:`, error);
    return '';
  }
};

export default fetchMigrationName;
